import { render, staticRenderFns } from "./ActivationsTable.component.vue?vue&type=template&id=536bbbb2"
import script from "./ActivationsTable.component.vue?vue&type=script&lang=js"
export * from "./ActivationsTable.component.vue?vue&type=script&lang=js"
import style0 from "./ActivationsTable.component.vue?vue&type=style&index=0&id=536bbbb2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports